// extracted by mini-css-extract-plugin
export var typingIndicator = "_rm-0";